<div class="tile__status tile__status--default" data-testid="tile">
    <div class="tile__svg--other-wrapper bg-img">
        <img class="tile__svg--other"
             ngSrc="{{ icon.setIcon(tile.params.iconId)}}"
             width="50" height="50" alt="" />
    </div>
    <div class=" font-13 tile__subtitle tile__subtitle--flex">
        <floating-subtitle [position]="'center'"
                           class="tile__subtitle-row tile__subtitle-row--center tile__subtitle-row--no-padding"
                           [text]="subtitle(3254) + ': ' + parameters.selectedModuleCompany.toUpperCase()">
        </floating-subtitle>
        <floating-subtitle [position]="'center'"
                           class="tile__subtitle-row tile__subtitle-row--center tile__subtitle-row--no-padding"
                           [text]="subtitle(tile.params.txtId) + ': ' + tile.params.controllerName">
        </floating-subtitle>
        <floating-subtitle [position]="'center'"
                           class="tile__subtitle-row tile__subtitle-row--center tile__subtitle-row--no-padding"
                           [text]="subtitle(3255) + ': ' + tile.params.version">
        </floating-subtitle>
        <floating-subtitle [position]="'center'"
                           class="tile__subtitle-row tile__subtitle-row--center tile__subtitle-row--no-padding"
                           *ngIf="tile.params.mainControllerId > 0"
                           [text]="subtitle(3256) + ': ' + tile.params.mainControllerId">
        </floating-subtitle>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
